import styled from "styled-components";
import { readStoredTheme, themeTokens } from "../theme";

const Page = styled.div<{ $dark: boolean }>`
  ${(p) => themeTokens(p.$dark)}

  flex: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  background: var(--bg-page);
  color: var(--text-primary);
`;

const Message = styled.p`
  margin: 0;
  font-size: 16px;
  text-align: center;
`;

const ReloadButton = styled.button`
  appearance: none;
  min-height: 44px;
  border-radius: 9px;
  border: 1px solid var(--border-chip);
  background: var(--bg-chip);
  color: var(--text-primary);
  padding: 9px 18px;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    background: var(--bg-chip-hover);
  }
`;

// Nothing catches a throw from here, so a wrong theme beats a blank page.
const isDark = () => {
  try {
    return readStoredTheme() === "dark";
  } catch {
    return false;
  }
};

// Shown by the app's error boundary, so a crash mid-talk is one tap to recover.
const CrashFallback = () => (
  <Page $dark={isDark()}>
    <Message>Something went wrong.</Message>
    <ReloadButton type="button" onClick={() => window.location.reload()}>
      Reload
    </ReloadButton>
  </Page>
);

export default CrashFallback;
